import { getYearFormatter } from "../../helpers";
import { getAuthHeaders, getAuthHeadersForFormData } from "../auth";
import {
  SUBMIT_TIME_SHEET,
  APPROVE_OR_REJECT_TIMESHEET,
  UPDATE_TIME_SHEET,
  FETCH_TIMESHEET_BY_ID,
  GET_SAVED_TIMESHEETS_INFO,
  GET_APPROVAL_LIST,
  DELETE_TIMESHEET_ATTACHMENT,
} from "../constants";
export const getFormattedTimeEntriesData = (transformedTimeEntries) => {
  const dateMap = new Map();
  for (const entry of transformedTimeEntries) {
    const date = entry.Date;
    const entryKey = `${date}-${entry.TaskType}-${entry.ProjectTaskID}-${entry.PayCode}`;
    if (!dateMap.has(entryKey)) {
      dateMap.set(entryKey, { nonZeroEntries: [], zeroEntries: [] });
    }

    if (entry.Hours > 0) {
      dateMap.get(entryKey).nonZeroEntries.push(entry);
    } else {
      dateMap.get(entryKey).zeroEntries.push(entry);
    }
  }
  const filteredData = [];
  dateMap.forEach(({ nonZeroEntries, zeroEntries }) => {
    if (nonZeroEntries.length > 0) {
      filteredData.push(...nonZeroEntries);
    } else if (zeroEntries.length > 0) {
      filteredData.push(zeroEntries[0]);
    }
  });
  return filteredData;
};
export const saveOrSubmitTimeSheetRequestConfig = (timesheetDetails) => {
  const { projectId, comments, status, timeEntryDetails, attachments } =
    timesheetDetails;

  const transformedTimeEntries = timeEntryDetails.map((tEntry) => {
    return {
      ProjectTaskID: tEntry.taskId,
      TaskType: tEntry.taskType,
      PayCode: tEntry.payCode,
      Hours: tEntry.payloadHours,
      Date: tEntry.date,
    };
  });

  const payloadEntries = getFormattedTimeEntriesData(transformedTimeEntries);
  const formattedPayloadEntries = payloadEntries.filter(
    (entry) => entry.ProjectTaskID
  );

  // Create FormData object
  const formData = new FormData();
  formData.append("ProjectID", projectId);
  formData.append("Comments", comments || "");
  formData.append("Status", status);

  // Append time entries as JSON string
  formData.append("Data", JSON.stringify(formattedPayloadEntries));

  // Append each file from attachments
  attachments?.forEach((att, index) => {
    if (att) {
      formData.append("Attachments", att); // Key must match backend expectation
    }
  });

  return {
    url: SUBMIT_TIME_SHEET,
    options: {
      method: "POST",
      headers: getAuthHeadersForFormData(true), // Don't manually set Content-Type
      body: formData,
    },
  };
};

export const updateTimeSheetRequestConfig = (timesheetDetails) => {
  const {
    projectId,
    comments,
    status,
    timeEntryDetails,
    timesheetId,
    attachments,
  } = timesheetDetails;

  const transformedTimeEntries = timeEntryDetails.map((tEntry) => {
    return {
      ProjectTaskID: tEntry.taskId,
      TaskType: tEntry.taskType,
      PayCode: tEntry.payCode,
      Hours: tEntry.payloadHours,
      Date: tEntry.date,
    };
  });

  const payloadEntries = getFormattedTimeEntriesData(transformedTimeEntries);
  const formattedPayloadEntries = payloadEntries.filter(
    (entry) => entry.ProjectTaskID
  );

  // Create FormData object
  const formData = new FormData();
  formData.append("TimesheetID", timesheetId);
  formData.append("ProjectID", projectId);
  formData.append("Comments", comments || "");
  formData.append("Status", status);

  // Append time entries as JSON string
  formData.append("Data", JSON.stringify(formattedPayloadEntries));

  // Append each file from attachments
  attachments?.forEach((att, index) => {
    if (att) {
      formData.append("Attachments", att); // Key must match backend expectation
    }
  });

  return {
    url: UPDATE_TIME_SHEET,
    options: {
      method: "PUT",
      headers: getAuthHeadersForFormData(true), // Don't manually set Content-Type
      body: formData,
    },
  };
};
export const getTmSheetSavedInfo = ({ startDate, endDate }) => {
  const payload = {
    StartDate: getYearFormatter(startDate),
    EndDate: getYearFormatter(endDate),
  };
  return {
    url: GET_SAVED_TIMESHEETS_INFO,
    options: {
      method: "POST",
      body: JSON.stringify(payload),
      headers: getAuthHeaders(),
    },
  };
};

export const getApprovalListServiceConfig = (options) => {
  const { page, pageSize, firstDay, lastDay } = options;
  const payload = {
    StartDate: getYearFormatter(firstDay),
    EndDate: getYearFormatter(lastDay),
    PageNo: page,
    PageSize: pageSize,
  };
  return {
    url: GET_APPROVAL_LIST,
    options: {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    },
  };
};

export const fetchTimesheetDetailsByIdReqConfig = (timesheetId) => {
  return {
    url: `${FETCH_TIMESHEET_BY_ID}?TimesheetID=${timesheetId}`,
    options: {
      method: "GET",
      headers: getAuthHeaders(),
    },
  };
};
export const getApproveRejectTimesheetServiceConfig = (
  ids,
  action,
  comments
) => {
  const payload = {
    TimesheetIDs: ids.join(","),
    ActionType: action,
    Comments: comments,
  };
  return {
    url: APPROVE_OR_REJECT_TIMESHEET,
    options: {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    },
  };
};

export const deleteTimesheetAttachmentConfig = (timesheetId, fileName) => {
  return {
    url: `${DELETE_TIMESHEET_ATTACHMENT}?TimesheetID=${timesheetId}&FileName=${fileName}`,
    options: {
      method: "DELETE",
      headers: getAuthHeaders(),
    },
  };
};
